<template>
  <Catalog
    title="Статус заказчика"
    name-label="Название статуса"
    submit-error="Укажите название статуса заказчика."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "CustomerStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getCustomerStatusById(id);
    },
    async putData(data) {
      return await this.putCustomerStatus(data)
    },
    async postData(data) {
      return await this.postCustomerStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CustomerStatuses/CustomerStatus.vue